export interface RaceAttemptResolution {
  attempt: number;
  restartAccepted: boolean;
  clearPending: boolean;
}

/** Reconciles restart acknowledgements delivered either by room-state or by a
 * reconnect welcome. Attempts are monotonic so a delayed packet cannot roll a
 * live client back to an older run. */
export function resolveRaceAttempt(
  currentAttempt: number,
  authoritativeAttempt: number | undefined,
  restartPending: boolean,
): RaceAttemptResolution {
  const current = normaliseAttempt(currentAttempt, 1);
  const authoritative = normaliseAttempt(authoritativeAttempt, current);
  const attempt = Math.max(current, authoritative);
  return {
    attempt,
    restartAccepted: attempt > current,
    clearPending: restartPending && attempt === current,
  };
}

function normaliseAttempt(value: number | undefined, fallback: number): number {
  return Number.isFinite(value) ? Math.max(1, Math.floor(Number(value))) : fallback;
}
